import { useQuery } from '@tanstack/react-query';
import { analyticsGetBranchReports } from '~/generated';
import { extractData } from '~/utils/query-utils';

export const useBranchReports = () =>
  useQuery({
    queryFn: async () => extractData(analyticsGetBranchReports()),
    queryKey: ['branchReports'],
  });
